import daysInFeb from './daysInFeb';

type DaysInMonth = {
  [key: string]: any,
}

const daysInMonth: DaysInMonth = {
  '01': 31,
  '02': (year: number) => daysInFeb(year),
  '03': 31,
  '04': 30,
  '05': 31,
  '06': 30,
  '07': 31,
  '08': 31,
  '09': 30,
  10: 31,
  11: 30,
  12: 31,
};

export default daysInMonth;
